export default "__VITE_ASSET__P7egZ_vT__"